// Handles both simulated checkout and real Razorpay Checkout.js.
let razorpayLoading = null;

function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (razorpayLoading) return razorpayLoading;
  razorpayLoading = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
  return razorpayLoading;
}

/**
 * Runs checkout for an order returned by /api/checkout.
 * Resolves with the confirm payload (empty for simulated / Paddle demo).
 * Rejects with Error('cancelled') if the user closes the Razorpay modal.
 */
export async function runCheckout(order, user) {
  if (order.simulated) return {};

  if (order.provider === "razorpay") {
    const ok = await loadRazorpay();
    if (!ok || !window.Razorpay) throw new Error("Could not load payment gateway");
    return new Promise((resolve, reject) => {
      const rzp = new window.Razorpay({
        key: order.key_id,
        amount: order.amount,
        currency: order.currency,
        order_id: order.order_id,
        name: "RelateMetrics",
        description: order.purpose?.replace("_", " "),
        prefill: {
          name: order.prefill_name || user?.name || "",
          email: order.prefill_email || user?.email || "",
        },
        theme: { color: "#6B21A8" },
        handler: (resp) => resolve({
          razorpay_payment_id: resp.razorpay_payment_id,
          razorpay_order_id: resp.razorpay_order_id,
          razorpay_signature: resp.razorpay_signature,
        }),
        modal: { ondismiss: () => reject(new Error("cancelled")) },
      });
      rzp.open();
    });
  }
  return {}; // Paddle demo / other
}
